<template>
    <div class="health-checks-container">
        <template v-if="radio !== null">
            <h1>{{ radio.label }} - {{ radio.serial_number }}</h1>
            <index-table
                title="Health Checks"
                :cols="columnDefinitions"
                alignCells="middle"
                :model="`asset-radios/${radioId}/health-checks`"
                :showTextSearch="false"
                defaultSort="client_received_at"
                defaultDir="desc"
                data-test-id="relay-health-checks-table"
            >
                <template #header>
                    <div></div>
                </template>
            </index-table>
        </template>
        <template v-else>
            <h1>All Radios</h1>
            <index-table
                title="Health Checks"
                :cols="columnDefinitions"
                alignCells="middle"
                :model="`relays/${relayId}/health-checks`"
                :showTextSearch="false"
                defaultSort="client_received_at"
                defaultDir="desc"
                data-test-id="relay-health-checks-table"
            >
                <template #header>
                    <div></div>
                </template>
            </index-table>
        </template>
    </div>
</template>
<script>
import IndexTable from '@/components/IndexTable/index.vue'

export default {
    components: { IndexTable },

    props: {
        radio: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            relayId: this.$route.params.id,
        }
    },

    computed: {
        radioId() {
            return this.radio.id
        },
        columnDefinitions() {
            const columnDefinitions = [
                {
                    label: 'Response Time (UTC)',
                    value: 'client_received_at',
                    searchable: false,
                    sortable: true,
                    filter: 'dateTime',
                },
                {
                    label: 'Battery',
                    value: 'battery_level',
                    searchable: false,
                    sortable: true,
                    customCell: 'HealthCheckBatteryCell',
                },
                {
                    label: 'Messages Received',
                    searchable: false,
                    sortable: false,
                    customCell: 'HealthCheckMessagesReceivedCell',
                },
                {
                    label: 'Antenna',
                    searchable: false,
                    sortable: false,
                    customCell: 'HealthCheckAntennaCell',
                },
                {
                    label: 'Temperature',
                    value: 'temperature',
                    searchable: false,
                    sortable: true,
                    customCell: 'HealthCheckTemperatureCell',
                },
                {
                    label: 'Firmware Vers.',
                    value: 'firmware_version',
                    searchable: false,
                    sortable: true,
                },
                {
                    label: 'Freq Set',
                    value: 'frequency_set_id',
                    searchable: false,
                    sortable: true,
                    customCell: 'HealthCheckFrequenciesCell',
                },
            ]
            if (this.radio === null) {
                columnDefinitions.splice(1, 0, {
                    label: 'Radio Name',
                    value: 'radio',
                    display: 'name',
                    searchable: false,
                    sortable: true,
                })
            }
            return columnDefinitions
        },
    },
}
</script>
<style lang="scss">
.health-checks-container {
    h1 {
        font-size: 24px;
        margin-top: 10px;
    }

    .module {
        margin-top: 0;
    }

    .module__search {
        justify-content: end;
    }

    .module__search,
    .module__body {
        padding: 0;
    }
}
</style>
